module.exports = __webpack_public_path__ + "img/log_pad.43fb3cdf.jpg";